import { ListChecks } from 'lucide-react';
import { materialRows, fmtQty } from '../lib/materialList';
import useCatalog from '../hooks/useCatalog';
import { eur } from '../lib/license';
import VatRows from './VatRows';

function Table({ t, data, testid }) {
  return (
    <table className="mat-table" data-testid={testid}>
      <thead><tr><th>{t.catName}</th><th>{t.colCount}</th><th>{t.colUnit}</th><th>{t.colUnitPrice}</th><th>{t.colAmount}</th></tr></thead>
      <tbody>
        {data.rows.map((r, i) => (
          <tr key={r.key} data-testid={`${testid}-row-${i}`}>
            <td>{r.label}{r.sku ? <small> · {r.sku}</small> : null}</td>
            <td>{fmtQty(r, t.locale)}</td>
            <td>{t['unit_' + r.unit] || r.unit}</td>
            <td>{r.price != null || r.install != null ? eur((+r.price || 0) + (+r.install || 0), t.locale) : '–'}</td>
            <td>{r.amount != null ? eur(r.amount, t.locale) : '–'}</td>
          </tr>
        ))}
      </tbody>
      <tfoot><VatRows t={t} net={data.total} span={4} testid={`${testid}-total`} /></tfoot>
    </table>
  );
}

export default function MaterialList({ t, project, reportId }) {
  useCatalog();
  const all = materialRows(project);
  if (!all.rows.length) return <div className="empty" data-testid="mat-list-empty">{t.matEmpty}</div>;
  const rep = materialRows(project, reportId);
  return (
    <div className="mat-list" data-testid="mat-list">
      <div className="sub-title"><ListChecks size={14} /> {t.matList}</div>
      {project.reports.length > 1 && rep.rows.length > 0 && <><b className="mat-sub">{t.matReport}</b><Table t={t} data={rep} testid="mat-report" /></>}
      <b className="mat-sub">{t.matProject}</b>
      <Table t={t} data={all} testid="mat-project" />
    </div>
  );
}
